/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   Simple accordion pattern example
 */

export default class PracticeAreaAccordion {
	start(domNode) {
		this.rootEl = domNode;
		this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');

		const controlsId = this.buttonEl.getAttribute('aria-controls');
		this.contentEl = document.getElementById(controlsId);

		this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';

		// add event listeners
		this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
	}

	onButtonClick() {
		this.toggle(!this.open);
	}

	toggle(open) {
		// Don't do anything if the open state doesn't change
		if (open === this.open) {
			return;
		}

		// Update the internal state
		this.open = open;

		// Handle DOM updates
		this.buttonEl.setAttribute('aria-expanded', `${open}`);

		if (open) {
			this.buttonEl.querySelector('.icon-modify').classList.remove('fa-plus');
			this.buttonEl.querySelector('.icon-modify').classList.add('fa-minus');
			this.contentEl.removeAttribute('hidden');
		} else {
			this.buttonEl.querySelector('.icon-modify').classList.remove('fa-minus');
			this.buttonEl.querySelector('.icon-modify').classList.add('fa-plus');
			this.contentEl.setAttribute('hidden', '');
		}
	}

	// Add public open and close methods for convenience
	open() {
		this.toggle(true);
	}

	close() {
		this.toggle(false);
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/practice-area-accordion.js